import { useMemo } from 'react';
import { FieldType } from 'modules/domains';
import { useUserMappingsQuery } from 'api/MappingsAPI';
import { isDefined } from 'utils/tsHelpers';
import { useToastNotification } from 'utils/hooks/useToastNotification';
import { useTranslation } from '../../../hooks/useTranslation';
import { useConditionState } from '../useConditionState';
import { filterByFieldType } from './utils';

export const useUserMappings = (fieldType?: FieldType) => {
  const { t } = useTranslation();
  const [{ field }] = useConditionState();
  const {
    data = [],
    isLoading,
    isError,
  } = useUserMappingsQuery({
    refetchOnWindowFocus: false,
    retry: false,
  });

  const userMappings = useMemo(
    () => (fieldType ? filterByFieldType(data, fieldType) : []),
    [data, fieldType],
  );

  useToastNotification({
    enabled: !isLoading && isDefined(data),
    negative: isError,
    negativeMessage: t('apiError.userMappings', { field }),
  });

  return {
    userMappings,
    isLoading,
  };
};
